export enum ComponentContentTypes {
  Page = 'page',
  PageWrapper = 'pageWrapper',
  SeoMetadata = 'seoMetadata',
  AssetImage = 'assetImage',
  AssetVideo = 'assetVideo',
  ComponentCtaButton = 'componentCtaButton',
  ComponentCtaGroup = 'componentCtaGroup',
  ComponentLink = 'componentLink',
  ComponentSocialShareWidget = 'componentSocialShareWidget',
  ComponentTitleBlockDescription = 'componentTitleDescriptionBlock',
  ComponentAssetGrid = 'componentAssetGrid',
  ItemTestimonial = 'itemTestimonial',
  ItemTab = 'itemTab',
  SectionFaq = 'sectionFaq',
  SectionHero = 'sectionHero',
  SectionMultiColumn = 'sectionMultiColumn',
  SectionSingleColumn = 'sectionSingleColumn',
  SectionTestimonials = 'sectionTestimonials',
  SectionTwoColumns = 'sectionTwoColumns',
  SingleColumn = 'singleColumn',
  SectionGroup = 'sectionGroup',
  VariationContainerDeviceType = 'variationContainerDeviceType',
  VariationContainerAuthAndDeviceTypeCta = 'variationContainerAuthAndDeviceTypeCta',
  SectionTabs = 'sectionTabs',
  ComponentBanner = 'componentBanner',
  AssetPdf = 'assetPdf',
}
